import { useEffect, useState, useRef, useMemo, useContext } from 'react';
import { ResponsiveLine } from "@nivo/line";
import { useTheme } from "@mui/material";
import { useHideMode, HideModeContext, tokens } from "../theme";

// This component assumes the data is ordered by date ascending

const NetWorthChart = ({ isDashboard = false, data = [] }) => {
    const theme = useTheme();
    const hideTheme = useHideMode();
    var [tickValues, setTickValues] = useState([]);

    useEffect(() => {
        setTickValues(data.map(datum => datum.x) // extract the 'x' property of each object
            .filter((x, index) => index % 14 === 0));
    }, [data])


    return (
        <ResponsiveLine
            data={[{
                id: 'data',
                color: tokens("dark").greenAccent[500],
                data: data
            }]}
            colors={isDashboard ? { datum: "color" } : { scheme: "nivo" }} // added
            // layers={['grid', 'areas']}
            margin={{ top: 50, right: 60, bottom: 50, left: 100 }}
            xScale={{ type: 'point' }}
            yScale={{
                type: 'linear',
                min: data[0]?.y - 0.1 * (data[data.length - 1]?.y - data[0]?.y),                    /* the minimum less 10% of the range */
                max: data[data.length - 1]?.y + 0.1 * (data[data.length - 1]?.y - data[0]?.y),      /* the maximum plus 10% of the range */
                stacked: true,
                reverse: false
            }}
            yFormat=" >-.2f"
            curve="linear"
            axisTop={null}
            axisRight={null}
            axisBottom={{
                orient: 'bottom',
                tickValues: tickValues,
                tickSize: 5,
                tickPadding: 5,
                tickRotation: -30,
                legend: 'Date',
                legendOffset: 40,
                legendPosition: 'middle'
            }}
            axisLeft=
            {
                hideTheme.mode === "hide" ? (null)
                    : (
                        {
                            orient: 'left',
                            tickSize: 5,
                            tickPadding: 5,
                            tickRotation: 0,
                            legend: 'Amount',
                            legendOffset: -60,
                            legendPosition: 'middle',

                        }
                    )
            }
            lineWidth={1}
            enablePoints={false}
            pointSize={2}
            pointColor={{ theme: 'background' }}
            pointBorderWidth={2}
            pointBorderColor={{ from: 'serieColor' }}
            pointLabelYOffset={-12}
            enableArea={true}
            areaBaselineValue={data[0]?.y - 0.1 * (data[data.length - 1]?.y - data[0]?.y)}
            useMesh={true}
            legends={[]}
            enablePointLabel={hideTheme.mode === "show"} // This has no effect for some reason
        />
    );
};

export default NetWorthChart;